"use client";

import { cn, type TabItem, Tabs } from "@kyan/ui";

import { LoadOrRender } from "#/components/LoadOrRender/LoadOrRender";
import { type TransformedOrderbook } from "#/types/orderbook";

import {
  type BookTradeTab,
  useBookAndTradesController,
} from "./BookAndTrades.controller";
import { OptionsLastTrades } from "./components/OptionsLastTrades/OptionsLastTrades";
import { OptionsOrderbook } from "./components/OptionsOrderbook/OptionsOrderbook";

const tabItems: TabItem<BookTradeTab>[] = [
  {
    id: "book",
    label: "Book",
    className: "w-1/2",
  },
  {
    id: "trades",
    label: "Trades",
    className: "w-1/2",
  },
];

interface BookAndTradesProps {
  className?: string;
}

export const BookAndTrades: React.FC<BookAndTradesProps> = ({ className }) => {
  const { tab, isRFQ, orders, isLoading, handleToggleTab } =
    useBookAndTradesController();

  if (isRFQ) return null;

  return (
    <div className={cn("mt-[9px] grid w-full", className)}>
      <LoadOrRender
        isLoading={isLoading}
        className="mb-3 h-[170px] w-full rounded-lg"
      >
        <div className="border-divider flex h-8 w-full items-center rounded-t border border-b-0">
          <Tabs
            value={tab}
            items={tabItems}
            variant="simple"
            className="w-full"
            onChange={handleToggleTab}
          />
        </div>
        <div className="flex w-full rounded-b">
          {tab === "book" && (
            <OptionsOrderbook orders={orders as TransformedOrderbook} />
          )}
          {tab === "trades" && <OptionsLastTrades />}
        </div>
      </LoadOrRender>
    </div>
  );
};
